import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Errors, Form } from 'react-redux-form';
import { Col, FormGroup, Row } from 'react-bootstrap';
import PageTitle from '../../../common/page-title';
import BackLink from '../../../common/back-link';
import RequiredInput from '../../../common/form/elements/required-input';
import ArrowButton from '../../../common/button-arrow';
import SearchableSelect from '../../../common/form/elements/searchable-select';
import { addManualPoints, getPointsDetails } from '../../../../actions/points';
import { isRrfFormValid } from '../../../../utils/commonFunctions';
import t from '../../../../data/translations';

const model = 'deep.user_point';

class ManualPointsTransactions extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPointsDetails(this.props.match.params.id));
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset(model));
    dispatch({ type: 'CLEAR_POINTS_DETAILS' });
  }

  selectPointPotBalance = () => {
    const {
      pointPotFormValue, details
    } = this.props;
    switch (pointPotFormValue) {
      case 'personal':
        return details.meta.owners[0].personal_balance;
      case 'personal_ngp':
        return details.meta.owners[0].personal_ngp_balance;
      case 'personal_postcode_plan':
        return details.meta.owners[0].personal_postcode_plan_balance;
      default:
        return '';
    }
  };

  onSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, addManualPoints(payload, this.props.match.params.id)));
  };

  isBalanceNegative = () => {
    const { valueFormValue } = this.props;
    const balance = this.selectPointPotBalance();
    const value = +valueFormValue;

    return value < 0 ? balance + value < 0 : false;
  }

  disableSubmit = () => {
    const { formValid, form } = this.props;

    return !formValid || !isRrfFormValid(form, { async: false }) || this.isBalanceNegative();
  };

  render() {
    const {
      isLoading, details, outletFormValue, pointPotFormValue
    } = this.props;
    let outlets = [];
    let pointPots = [];
    let owner = {};

    if (details.meta) {
      pointPots = Object.entries(details.meta.point_pots).map(([key, value]) => ({ label: value, value: key }));
      outlets = details.meta.owners[0].outlets
        .map(outlet => ({ label: outlet.name, value: outlet.id })) || [];
      [owner] = details.meta.owners;
    }

    return (
      <div className="container-fluid">
        <PageTitle>
          Add manual points to {owner.name}
        </PageTitle>
        <Col md={12}>
          <Row>
            <BackLink href="/admin/points-transactions"/>
          </Row>
          <Row>
            <p>
              { t('manualPointTransaction.note') }
            </p>
          </Row>
        </Col>
        {isLoading ? (
          <Col md={12}>
            <Row>
            Loading...
            </Row>
          </Col>
          ) : (
            <Col md={12}>
              <Row>
                <Form
                  model={model}
                  onSubmit={this.onSubmit}
                >
                  <Errors className="errors" model={model} />
                  <Row>
                    <Col lg={12}>
                      <FormGroup controlId="outlets">
                        <label>
                          Store
                        </label>
                        <SearchableSelect
                          model={`${model}.outlet`}
                          options={outlets}
                          value={outletFormValue || ''}
                          disabled={outlets.length === 0}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <FormGroup controlId="point_pots">
                        <label>
                          Point Pot*
                        </label>
                        <SearchableSelect
                          model={`${model}.point_pot`}
                          options={pointPots}
                          value={pointPotFormValue || ''}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <RequiredInput
                        controlId="value"
                        label="Value (points)"
                        model={`${model}.value`}
                        placeholder="0"
                        type="number"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <RequiredInput
                        controlId="description"
                        label="Description"
                        model={`${model}.description`}
                        placeholder="Description"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      Balance: {this.selectPointPotBalance()}
                    </Col>
                  </Row>
                  {this.isBalanceNegative() && (
                  <Row>
                    <Col md={12}>
                      Not enough points to remove.
                    </Col>
                  </Row>
                  )}
                  <Col md={12}>
                    <Row>
                      <ArrowButton
                        className="float-right"
                        disabled={this.disableSubmit()}
                      >
                        Process
                      </ArrowButton>
                    </Row>
                  </Col>
                </Form>
              </Row>
            </Col>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.points.fetching && !state.points.fetched,
  details: state.points.details,
  outletFormValue: state.deep.user_point.outlet,
  pointPotFormValue: state.deep.user_point.point_pot,
  valueFormValue: state.deep.user_point.value,
  formValid: state.deep.forms.user_point.$form.valid
});

export default connect(mapStateToProps)(ManualPointsTransactions);



// WEBPACK FOOTER //
// ./src/components/admin/points/manual-points-transactions/index.jsx